import { useCallback, useEffect, useState } from 'react';
import { getRentCredit, getWalletHistory } from '../../../auth/_requests';
import type { WalletHistoryItem, rentCreditResponse } from '../../../helpers/utils/types';

const EMPTY_STATS: rentCreditResponse = {
  totalRentCredit: 0,
  totalAvailable: 0,
  totalRedeemed: 0,
};

export const useRentCreditHistory = (token?: string) => {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState<WalletHistoryItem[]>([]);
  const [stats, setStats] = useState<rentCreditResponse>(EMPTY_STATS);

  const fetchHistory = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    try {
      const [historyResponse, statsResponse] = await Promise.all([
        getWalletHistory(token),
        getRentCredit(token),
      ]);
      setItems(historyResponse?.data ?? []);
      setStats(statsResponse ?? EMPTY_STATS);
    } catch (error) {
      console.error('Error fetching rent credit history:', error);
      setItems([]);
      setStats(EMPTY_STATS);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    void fetchHistory();
  }, [fetchHistory]);

  return { items, stats, loading, refetch: fetchHistory };
};
